import type { FC, ReactNode } from 'react';
import { useEffect, useContext, memo } from 'react';

import { EditorContextPanelContext } from './EditorContextPanelContext';

type Props = {
	itemName: string;
	closeSelf: () => void;
	children: ReactNode;
	closeLabel: string;
	closeAutoFocus?: boolean;
	hasPadding?: boolean;
	customWidth?: number;
};

export const EditorContextPanelItem: FC<Props> = memo(
	({
		itemName,
		children: component,
		closeSelf,
		closeLabel,
		closeAutoFocus = false,
		hasPadding = true,
		customWidth,
	}) => {
		const { setItem, removeItem } = useContext(EditorContextPanelContext);

		// remove the item on unmount
		useEffect(() => {
			return () => {
				removeItem(itemName);
			};
		}, [itemName, removeItem]);

		useEffect(() => {
			if (component) {
				setItem({
					itemName,
					component,
					close: closeSelf,
					closeLabel,
					closeAutoFocus,
					hasPadding,
					customWidth,
				});
			} else {
				removeItem(itemName);
			}
		}, [
			component,
			itemName,
			setItem,
			removeItem,
			closeSelf,
			closeLabel,
			closeAutoFocus,
			hasPadding,
			customWidth,
		]);

		return null;
	},
);
